/**
 * @module components\ghInput\qrcodeInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";
import { Prop, Watch } from 'vue-property-decorator';
import jrQrcode from 'jr-qrcode';

@Component
export default class QrcodeInput extends InputBase {
  mounted() {
    this.refresh();
  }

  @Watch("value")
  private refresh(){
    let code=this.$refs.qrcode as HTMLImageElement;
    code.src=jrQrcode.getQrBase64(this.value);
  }
}
